import axios from 'axios';
import { TokenType } from 'types/Enums';

const API_URL = process.env.REACT_APP_API_URL;

const axiosServices = axios.create({
  baseURL: API_URL
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response.status;

    if (status === 401 && !originalRequest._retry && !window.location.href.includes('/login')) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem(TokenType.REFRESH_TOKEN);

        const refreshResponse = await axios.post(`${API_URL}/token_refresh`, {
          refresh_token: refreshToken
        });

        const token = refreshResponse.data.access_token;
        const refreshTokenNew = refreshResponse.data.refresh_token;

        localStorage.setItem(TokenType.ACCESS_TOKEN, token);
        localStorage.setItem(TokenType.REFRESH_TOKEN, refreshTokenNew);

        originalRequest.headers['Authorization'] = `Bearer ${token}`;
        return axiosServices(originalRequest);
      } catch (err) {
        console.error('Token refresh failed:', err);
        localStorage.removeItem(TokenType.ACCESS_TOKEN);
        localStorage.removeItem(TokenType.REFRESH_TOKEN);
        window.location.href = '/login';
      }
    }

    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;
